<template>
    <button class="btn btn-success btn-block"  :title="this.$root.trans.save" @click.prevent="doUpdate()"><i class="ti-save"></i></button>    
</template>

<script>
    export default {
        components: {
        },
        props: {
        },
        data () {
            return {
            }
        },
        computed:{
        },
        mounted() {
			
        },
        methods: {
           doUpdate(){
               this.$emit('doUpdate');
           }
		},
        watch: {
            
        },
    }
</script>




